"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Chargeback_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chargeback = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const PaymentType_1 = require("../domain/PaymentType");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
let Chargeback = Chargeback_1 = class Chargeback {
    _id = (0, uuid_1.v4)();
    paymentId;
    orderId = null;
    amount;
    currency = legacy_enums_1.Currency.Euro;
    gatewayId;
    type;
    description;
    createdAt = new Date();
    fulfilledAt;
    failedAt;
    createdBy;
    get status() {
        return (0, statusGetter_1.statusGetter)(this, Chargeback_1, legacy_enums_1.ChargebackStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case legacy_enums_1.ChargebackStatus.Failed:
                return {
                    failedAt: defined,
                };
            case legacy_enums_1.ChargebackStatus.Fulfilled:
                return {
                    failedAt: undefined,
                    fulfilledAt: defined,
                };
            case legacy_enums_1.ChargebackStatus.Pending:
            default:
                return {
                    failedAt: undefined,
                    fulfilledAt: undefined,
                };
        }
    }
};
exports.Chargeback = Chargeback;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Chargeback.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((c) => (0, utils_1.isUndefinedOrNull)(c.orderId)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Chargeback.prototype, "paymentId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((c) => (0, utils_1.isUndefinedOrNull)(c.paymentId)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Chargeback.prototype, "orderId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Chargeback.prototype, "amount", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Chargeback.prototype, "currency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((p) => p.type === PaymentType_1.PaymentType.Mangopay || p.type === PaymentType_1.PaymentType.Paypal),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Chargeback.prototype, "gatewayId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Chargeback.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((c) => c.type === PaymentType_1.PaymentType.Other),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Chargeback.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => (!value ? undefined : new Date(value))),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], Chargeback.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Chargeback.prototype, "fulfilledAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Chargeback.prototype, "failedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Chargeback.prototype, "createdBy", void 0);
exports.Chargeback = Chargeback = Chargeback_1 = __decorate([
    (0, typeorm_1.Entity)("chargebacks")
], Chargeback);
//# sourceMappingURL=Chargeback.js.map